var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "work_accomplished_web",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,4.11H14.82a3,3,0,0,0-5.64,0H5a2,2,0,0,0-2,2v14a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-14A2,2,0,0,0,19,4.11Zm-7,0a1,1,0,1,1-1,1A1,1,0,0,1,12,4.11Zm-2,14-4-4L7.41,12.7,10,15.28l6.59-6.59L18,10.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/progress_icon.6d3f3945ae00caf6cad8858154299ae4.svg";
export { ForwardRef as ReactComponent };